module.exports = __webpack_public_path__ + "static/img/workSite1.c1a6f56.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/workSite1.png
// module id = lsOB
// module chunks = 1